import React from 'react';
import {Link} from "react-router-dom";

function OutlineButton({name, to}) {
    return (
        <Link to={to}>
            <button className={"rounded-lg border-2 px-6 h-10 text-primary font-bold border-primary"}>
                {name}
            </button>
        </Link>
    );
}

export default OutlineButton;